import { useEffect, useMemo, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { api } from "../../lib/api";
import { Search, PackageCheck } from "lucide-react";

const money = (v) => `R$ ${Number(v).toFixed(2).replace(".", ",")}`;

export default function Estoque() {
  const { unidade } = useOutletContext();
  const [estoque, setEstoque] = useState([]);
  const [busca, setBusca] = useState("");

  useEffect(() => {
    api.get("/estoque", { params: { unidade_id: unidade.id } }).then((r) => setEstoque(r.data));
  }, [unidade.id]);

  const lista = useMemo(() => {
    const q = busca.trim().toLowerCase();
    if (!q) return estoque;
    return estoque.filter(
      (e) =>
        e.produto_nome.toLowerCase().includes(q) ||
        (e.categoria || "").toLowerCase().includes(q)
    );
  }, [estoque, busca]);

  return (
    <div>
      <div className="flex items-end justify-between mb-6">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-500">
            Consulta
          </p>
          <h2 className="font-display text-3xl sm:text-4xl font-black tracking-tighter">
            Estoque da Unidade
          </h2>
        </div>
        <div className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-neutral-500">
          <PackageCheck className="w-4 h-4" /> Somente leitura
        </div>
      </div>

      <div className="bg-white border-2 border-neutral-900">
        <div className="p-3 border-b-2 border-neutral-900 relative">
          <Search className="w-4 h-4 absolute left-5 top-1/2 -translate-y-1/2 text-neutral-500" />
          <input
            data-testid="estoque-busca-input"
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
            placeholder="Buscar produto..."
            className="w-full h-10 pl-8 pr-3 font-mono text-sm focus:outline-none"
          />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-neutral-300 bg-neutral-50">
                <th className="text-left p-3 font-mono text-[10px] uppercase tracking-widest text-neutral-600">
                  Produto
                </th>
                <th className="text-left p-3 font-mono text-[10px] uppercase tracking-widest text-neutral-600 hidden sm:table-cell">
                  Categoria
                </th>
                <th className="text-right p-3 font-mono text-[10px] uppercase tracking-widest text-neutral-600">
                  Quantidade
                </th>
                <th className="text-right p-3 font-mono text-[10px] uppercase tracking-widest text-neutral-600">
                  Preço Venda
                </th>
              </tr>
            </thead>
            <tbody>
              {lista.map((e) => (
                <tr
                  key={e.id}
                  data-testid={`estoque-row-${e.produto_id}`}
                  className="border-b border-neutral-100 hover:bg-neutral-50"
                >
                  <td className="p-3 font-display font-bold">{e.produto_nome}</td>
                  <td className="p-3 text-sm text-neutral-600 hidden sm:table-cell">
                    {e.categoria}
                  </td>
                  <td className="p-3 text-right font-mono font-bold">
                    <span
                      className={`inline-block px-2 py-0.5 ${
                        e.quantidade_atual === 0
                          ? "bg-red-100 text-red-700"
                          : e.quantidade_atual < 10
                          ? "bg-yellow-100 text-yellow-800"
                          : "bg-neutral-100"
                      }`}
                    >
                      {e.quantidade_atual}
                    </span>
                  </td>
                  <td className="p-3 text-right font-mono font-bold">
                    {money(e.preco_venda)}
                  </td>
                </tr>
              ))}
              {lista.length === 0 && (
                <tr>
                  <td colSpan={4} className="p-8 text-center text-sm text-neutral-500">
                    Nenhum item encontrado
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
